<template>
	<vSelect
		:clearable="false"
		:searchable="true"
		:placeholder="placeholder"
		:options="formattedOptions"
		:selectable="selectable"
		@option:selected="($event) => $emit('change', $event)"
	>
		<template #no-options="{ search, searching, loading }">
			Ingen resultater
		</template>
		<template #option="{ label, isCategory }">
			<div class="select-category" v-if="isCategory && label">
				<label class="d-block font-bold">{{ label }}</label>
			</div>
			<div v-else>{{ label }}</div>
		</template>
	</vSelect>
</template>
<script setup>
import { h, computed, ref } from "vue";
import vSelect from "vue-select";

const props = defineProps({
	options: Array,
	placeholder: String,
});

const options = ref(props.options);

const formattedOptions = computed(() => {
	const newOptions = [...options.value].filter((item) => item.category_id);

	const uniqueCategories = [
		...new Set(newOptions.map((item) => item.category)),
	];
	uniqueCategories.sort();

	const dropdownOptions = [];

	const placeholderOption = options.value.find((item) => item.option === 0);
	if (placeholderOption) dropdownOptions.push(placeholderOption);

	uniqueCategories.forEach((category) => {
		// Get options for the current category
		const categoryOptions = newOptions.filter(
			(item) => item.category === category,
		);
		const nonPlaceholderOptions = categoryOptions.filter(
			(item) => item.option !== 0,
		);

		if (nonPlaceholderOptions.length > 0) {
			dropdownOptions.push({
				option: "",
				label: category,
				isCategory: true,
			});

			// Map options to array of options
			const mappedOptions = nonPlaceholderOptions
				.sort((a, b) => a.label.localeCompare(b.label))
				.map((item) => ({
					...item,
				}));
			dropdownOptions.push(...mappedOptions);
		}
	});

	return dropdownOptions;
});

const selectable = (option) => {
	return !option.isCategory;
};

vSelect.props.components.default = () => ({
	OpenIndicator: {
		render: () =>
			h("span", {
				class: { toggle: true },
				innerHTML: '<b role="presentation"></b>',
			}),
	},
});
</script>
